import _ from 'lodash';

// use localStorage to store the authority info, which might be sent from server in actual project.
export function getAuthority(str) {
  const authorityString = typeof str === 'undefined' ? localStorage.getItem('authority') : str;
  // authorityString could be authentication, "authentication", ["authentication"]
  let authority;

  try {
    authority = JSON.parse(authorityString);
  } catch (e) {
    authority = authorityString;
  }

  if (_.isArray(authority)) {
    return authority;
  }
  if (_.isString(authority)) {
    return authority.split(',');
  }
  return [];
}

export function setAuthority(authority) {
  const proAuthority = _.isArray(authority) ? authority.join(',') : authority;
  return localStorage.setItem('authority', JSON.stringify(proAuthority));
}

export function removeAuthority() {
  localStorage.removeItem('authority');
}
